import React, { useRef } from "react";
import {useNavigate} from "react-router-dom";

function Banner() {
    const searchInput = useRef();
    const navigation =useNavigate();

    return (
        <div className="max-w-[1400px] mx-auto">

            <div className="h-[300px] bg-gradient-to-r from-cyan-500 to-blue-500 py-5">
                <div className="flex flex-col gap-10 px-10 py-10">
                    <div className="text-white">
                        <h1 className="font-black text-5xl">Welcome to the World of Entertainment.</h1>
                    </div>

                    <div className="relative">
                        <input type='text' ref={searchInput} className="w-full h-11 rounded-[8rem] outline-none px-5 py-3 placeholder:text-slate-400 text-[1.2rem]" placeholder="Search Trending Here" />
                        <div>
                        <button className="h-11 text-white font-bold px-7 py-3 rounded-[8rem] bg-gradient-to-r from-lightGreen to-lightBlue absolute top-0 right-0 hover:text-black inline-flex justify-center items-center" onClick={() => navigation(`/search/${searchInput.current.value}`)} >
                            Search
                        </button>
                    </div>
                    </div>

                    
                </div>
            </div>
        </div>
    );

}

export default Banner;
